import { Field, Image, ImageField, Text, useSitecoreContext } from '@sitecore-jss/sitecore-jss-nextjs';

import { ComponentProps, SitecoreContextValue } from 'lib/ComponentProps';

import { FieldEditFrame } from 'src/utils/customFieldEditFrame';
import IsSitecoreEditing from 'src/utils/isSitecoreEditing';

import ContentOverviewHeaderContainer from 'src/components/contentOverview/_contentOverviewHeaderContainer/ContentOverviewHeaderContainer';
import { EditorHelp } from 'src/components/layout/_EditorHelp/_EditorHelp';

import StarIconSvg from 'public/icons/star.svg';

import styles from './CourseOverviewTestimonialList.module.css';

type CourseOverviewTestimonialListProps = ComponentProps & {
	fields: {
		TestimonialsTitle: Field<string>;
		Testimonials: [
			{
				fields: {
					Rating: Field<string>;
					Testimonial: Field<string>;
					Name: Field<string>;
					Role: Field<string>;
					Image: ImageField;
				};
			}
		];
	};
};

export default function CourseOverviewTestimonialList(props: CourseOverviewTestimonialListProps): JSX.Element {
	const { sitecoreContext } = useSitecoreContext<SitecoreContextValue>();
	const isEditing = IsSitecoreEditing();

	if (!isEditing && props.fields?.Testimonials?.length < 1) {
		return <></>;
	}

	return (
		<section className="maxWidth padX padYL" data-display-pdf-download>
			<ContentOverviewHeaderContainer header={props.fields?.TestimonialsTitle?.value} />

			<FieldEditFrame itemId={sitecoreContext?.itemId ?? undefined} fields={['Testimonials']} header="Edit Testimonials">
				<EditorHelp text={'Click here to select the testimonials'} />
				<div className={styles.testimonialsGrid}>
					{props.fields?.Testimonials?.map((testimonial, index) => (
						<div className={styles.testimonialCard} key={index}>
							{testimonial.fields?.Rating?.value && (
								<span className={styles.testimonialStars}>
									{[...Array(parseInt(testimonial.fields.Rating.value))].map((rating, jIndex) => (
										<StarIconSvg className={styles.starIcon} title={rating} key={jIndex} />
									))}
								</span>
							)}

							<Text tag="p" className={styles.testimonialQuote} field={testimonial.fields?.Testimonial} />

							<hr className={styles.horizontalRule} />

							<div className={styles.testimonialFooter}>
								<Image className={styles.testimonialImage} media={testimonial.fields?.Image} />

								<div className={styles.testimonialFooterText}>
									<Text tag="p" field={testimonial.fields?.Name} className={styles.testimonialName} />

									<Text tag="small" field={testimonial.fields?.Role} />
								</div>
							</div>
						</div>
					))}
				</div>
			</FieldEditFrame>
		</section>
	);
}
